import { HearingRecordRequirement } from "./hearing-record.models";

/** Notification tasks include every recorded participant group, while retaining the
 * original requirement label so victim-specific obligations remain distinguishable.
 * The current hearing projection exposes labels rather than stable requirement codes. */
export function isParticipantNotificationRequirement(requirement: HearingRecordRequirement): boolean {
  const label = (requirement.label ?? "").toLowerCase().replace(/[^a-z]/g, "");
  return /^(?:victims?(?:vnoks?|andvnoks?|nextofkin)?|participants?|vnoks?|nextofkin|attorneys?|counsel|witness(?:es)?|representatives?|supportpersons?|supportpeople|hearingpanel|panelmembers?|hearing)(?:notifications?|notices?)$/.test(label);
}

export function isHearingRequirementComplete(requirement: HearingRecordRequirement): boolean {
  return ["complete", "completed", "satisfied", "final"].includes((requirement.statusCode ?? "").trim().toLowerCase());
}
